<template>
  <div class="standings-player-details-section">
    <div v-if="playerData.headerImgPath" class="standings-player-details-section__header">
      <img
        class="standings-player-details-section__header-img"
        :src="playerData.headerImgPath"
        alt=""
      />
      <svg
        class="standings-player-details-section__header-mask"
        width="375"
        height="88"
        viewBox="0 0 375 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path d="M0 87.5589L375 0V87.5589H0Z" fill="white" />
      </svg>
    </div>

    <div class="standings-player-details-section__main">
      <figure class="standings-player-details-section__player-img">
        <img :src="playerData.playerImgPath" :alt="playerData.name" />
      </figure>
      <div class="standings-player-details-section__content">
        <div class="standings-player-details-section__profile">
          <p class="standings-player-details-section__profile-name">
            <span v-text="playerData.name"></span>
          </p>
          <p class="standings-player-details-section__profile-team" v-text="playerData.team" />
        </div>
        <div class="standings-player-details-section__other">
          <button
            class="standings-player-details-section__favorite"
            :class="{ 'standings-player-details-section__favorite--active': isFavoritePlayer }"
            type="button"
            @click="onclickFavorite"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.0133 5.56322L16.0141 5.56619C16.0926 5.86807 16.1299 6.17916 16.1251 6.49103L16.125 6.49917L16.125 6.5073C16.1287 7.09584 15.9738 7.67451 15.6765 8.18245L15.6711 8.19161L15.666 8.20091C15.5222 8.46336 15.339 8.70371 15.1241 8.91411L15.1241 8.91408L15.1184 8.91973L9 15.0382L2.88158 8.91973L2.88159 8.91973L2.87954 8.9177C2.6614 8.70122 2.47251 8.45716 2.31767 8.19171C2.17443 7.9311 2.06269 7.65436 1.98483 7.36734C1.91183 7.08707 1.875 6.79641 1.875 6.50257H1.87509L1.87492 6.49112C1.87015 6.17919 1.90749 5.86805 1.98592 5.56611L1.98596 5.56613L1.98796 5.55806C2.13358 4.97072 2.44059 4.43584 2.87428 4.01385L2.87432 4.01389L2.88069 4.00753C3.20165 3.68765 3.58163 3.43309 3.99956 3.25796C4.83883 2.91422 5.77956 2.91401 6.61895 3.25735C7.00387 3.42078 7.35865 3.64739 7.66866 3.92774L7.69259 3.95645L7.71437 3.98259L7.73842 4.00665L8.46967 4.7379L9 5.26823L9.53033 4.7379L10.2616 4.00664L10.2856 3.98259L10.3074 3.95645L10.3313 3.92774C10.6414 3.64739 10.9961 3.42078 11.381 3.25736C12.2204 2.91401 13.1612 2.91421 14.0004 3.25796C14.4184 3.43308 14.7983 3.68764 15.1193 4.00753L15.1192 4.0076L15.128 4.01602C15.3418 4.2224 15.5227 4.46049 15.6641 4.7219L15.6702 4.73315L15.6766 4.74419C15.8266 5.00013 15.9399 5.27582 16.0133 5.56322Z"
                stroke="black"
                stroke-width="1.5"
              />
            </svg>
            <span
              v-text="
                isFavoritePlayer
                  ? $tc('StandingsPage.DetailsPage.settingFavorite')
                  : $tc('StandingsPage.DetailsPage.addFavorite')
              "
            />
          </button>

          <a
            class="standings-player-details-section__profile-link"
            :href="playerData.profileLink"
            target="_blank"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7.28571 3H3V15H15V10.7143" stroke="black" stroke-width="1.5" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.4391 2.5H11.5001L10.0001 1H11.5001H16.0001C16.5524 1 17.0001 1.44772 17.0001 2V6.5V8L15.5001 6.5V3.5603L9.1798 9.88064L8.11914 8.81998L14.4391 2.5Z"
                fill="black"
              />
            </svg>

            <span v-text="$tc('StandingsPage.DetailsPage.ViewDriversProfile')" />
          </a>
        </div>
      </div>
    </div>

    <standings-player-result-parts
      class="standings-player-details-section__result"
      :totalPosition="playerData.totalPosition"
      :totalPoints="playerData.totalPoints"
    />

    <router-link
      class="standings-player-details-section__back-link"
      to="/standings?fromDetails=true"
    >
      <img :src="require('@/assets/img/icon/icon_chevron_left_24__white.svg')" alt="<" />
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import StandingsPlayerResultParts from '@/components/StandingsPage/StandingsPlayerDetailsPane/parts/StandingsPlayerResultParts.vue'

export type StandingPlayerDetailsType = {
  headerImgPath: string
  playerImgPath: string
  number: string
  name: string
  team: string
  profileLink: string
  totalPosition: number
  totalPoints: number
}

/**
 * Standings: 選手リストセクション
 */
export default defineComponent({
  name: 'StandingsPlayerDetailsSection',
  components: {
    StandingsPlayerResultParts,
  },
  props: {
    playerData: {
      type: Object as PropType<StandingPlayerDetailsType>,
      required: true,
    },
    isFavoritePlayer: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onclickFavorite() {
      this.$emit('onChangeFavoritePlayer')
    },
  },
})
</script>

<style lang="scss" scoped>
.standings-player-details-section {
  position: relative;
  width: 100%;
  padding-top: min(#{convertPXtoVW(160)}, 220px);
  background: $white;

  @media screen and (min-width: 390px) {
    padding-top: min(#{convertPXtoVW(170)}, 220px);
  }

  &__header {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: min(#{convertPXtoVW(214)}, 250px);
    text-align: center;
    background: $black;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      content: '';
      width: 100%;
      height: min(#{convertPXtoVW(88)}, 88px);
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 100%);
    }

    &-img {
      width: 100%;
      max-width: 768px;
      height: min(#{convertPXtoVW(214)}, 250px);
      object-position: center top;
      object-fit: cover;
    }

    &-mask {
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: min(#{convertPXtoVW(88)}, 88px);
    }
  }

  &__main {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
    justify-content: center;
    width: min(100%, 418px);
    padding-left: min(#{convertPXtoVW(6)}, 6px);
    padding-bottom: min(#{convertPXtoVW(24)}, 24px);
    margin: 0 auto;

    @media screen and (min-width: $responsiveTabletWidth - 1px) {
      justify-content: space-between;
      padding-left: 0;
      padding-right: 35px;
      width: min(100%, 428px);
    }
  }

  &__player-img {
    position: relative;
    width: min(#{convertPXtoVW(168)}, 168px);

    img {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-items: flex-end;
    gap: min(#{convertPXtoVW(12)}, 12px);
    width: calc(100% - min(#{convertPXtoVW(168)}, 168px));
    padding: 0 min(#{convertPXtoVW(20)}, 20px) 0 min(#{convertPXtoVW(10)}, 10px);
    max-width: 202px;
    text-align: center;

    @media screen and (min-width: $responsiveTabletWidth - 1px) {
      padding: 0;
      max-width: 168px;
    }
  }

  &__profile {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-items: center;
    gap: min(#{convertPXtoVW(8)}, 8px);
    width: 100%;
    letter-spacing: 0.04em;

    &-name {
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-items: center;
      font-weight: 600;
      font-size: min(#{convertPXtoVW(16)}, 16px);
      font-family: $fontHeading;
      line-height: 1.25;
      color: $black;
      padding-top: 12px;

      &__number {
        font-size: min(#{convertPXtoVW(14)}, 14px);
        line-height: 1.57;
        text-transform: uppercase;
      }
    }

    &-team {
      font-weight: 500;
      font-size: min(#{convertPXtoVW(12)}, 12px);
      line-height: 1.33;
      color: $gray50;
    }
  }

  &__other {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-items: center;
    gap: min(#{convertPXtoVW(8)}, 8px);
    width: 100%;
  }

  &__favorite,
  &__profile-link {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    gap: min(#{convertPXtoVW(4)}, 4px);
    font-family: $fontSignup;
    font-weight: 500;
    font-size: min(#{convertPXtoVW(10)}, 10px);
    line-height: 1.4;
    letter-spacing: 0.04em;
    font-feature-settings: 'palt' on;

    svg {
      width: min(#{convertPXtoVW(18)}, 18px);
    }
  }

  &__favorite {
    &--active {
      color: $green-link;
      pointer-events: none;

      svg path {
        stroke: none;
        fill: $green-link;
      }
    }
  }

  &__back-link {
    position: absolute;
    top: min(#{convertPXtoVW(8)}, 8px);
    left: min(#{convertPXtoVW(8)}, 8px);
    display: flex;
    align-items: center;
    justify-content: center;
    width: min(#{convertPXtoVW(28)}, 28px);
    height: min(#{convertPXtoVW(28)}, 28px);

    img {
      width: min(#{convertPXtoVW(18)}, 18px);
    }
  }

  @media screen and (min-width: 580px) {
    padding-top: 240px;

    &__header {
      height: 285px;

      &-img {
        height: 285px;
      }
    }
  }

  @media screen and (min-width: $responsiveTabletWidth - 1px) {
    padding-top: 270px;

    &__header {
      height: 310px;

      &-img {
        height: 310px;
      }
    }
  }
}
</style>
